import { type FunctionComponent, type ReactNode, useState } from 'react';

import Table from 'components/Table';
import { AdminPage } from 'components/admin';
import AddNewButton from 'components/admin/AddNewButton';

import useBlogItemList from 'hooks/blog/useBlogItemList';

import {
  E_ADD_NEW,
  P_ADMIN_BLOG,
  getId,
  useGlobalState,
} from 'utils';

import Item from './Item';

import S from './style.scss';

const AdminBlogEditorPage: FunctionComponent = () => {
  const [user] = useGlobalState('user');
  if (!user) throw Error('Unauthorized');

  if (!user.permissions.BLOG_EDITOR) throw Error('Forbidden');

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // TODO: If we stay on the page, and the head media of some blog posts
  // are videos,  and are not yet ready to be played... we need to periodically
  // refresh the ready to play status in the background.

  // TODO: Wire up the text search.

  const blog = useBlogItemList({
    page,
    pageSize,
    query: {},
  });

  const blogItems: ReactNode[] = [];
  for (const item of blog.items) {
    blogItems.push(<Item item={item} key={getId(item)} />);
  }

  return (
    <AdminPage
      contentClassName={S.container}
      subTitle="Create, edit, manage blog posts"
      title="Blog Editor"
    >
      <div styleName="header">
        <AddNewButton
          hideLabelOnMobile
          label="Add New Blog Item"
          to={`${P_ADMIN_BLOG}${E_ADD_NEW}`}
        />
      </div>
      <Table
        busy={blog.loading}
        numPages={blog.numPages ?? 1}
        page={page}
        pageSize={pageSize}
        pageSizeOptions={[10, 50, 100]}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        <thead>
          <tr>
            <th>Cover Image</th>
            <th>Title</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {blogItems}
        </tbody>
      </Table>
    </AdminPage>
  );
};

export default AdminBlogEditorPage;
